import { render } from "./Pagination.vue?vue&type=template&id=75262f01&scoped=true"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import "./Pagination.vue?vue&type=style&index=0&id=75262f01&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75262f01"]])

export default __exports__